<template>
  <div class="form-group">
    <span :class="{'input-group-addon':1, 'text-primary':codeFocus}" @click="codeFocus=1"><Icon type="md-key"></Icon></span>
    <Poptip v-model="codeError" :content="warn" placement="right">
      <input @keyup.enter="$emit('done')" @input="codeError=false" v-focus="codeFocus" @focus="doFocus" @blur="doBlur" v-model="user.ic" :placeholder="message.content.input.replace('%', userform.field.code)" maxlength="6" style="padding-left:35px" type="text" autocomplete="off" class="form-control">
    </Poptip>
    <a role="button" :class="'btn btn-primary btn-code btn' + (codeGot ? '-disabled' : '')" @click="getCode">{{codeAction}}</a>
  </div>
</template>
<script>
import { Icon, Button } from 'iview'
import { actions, userform, message } from '../locale'
import { vFocus } from '../utils'
import Poptip from './login/Poptip'

const msgType = {
  forgot: 1, // 找回密码
  reg: 2, // 注册账号
  login: 3, // 验证码登录
  modify: 4 // 变更账号
}

export default {
  name: 'CodeGetter',
  props: ['process', 'user', 'mobileError'],
  data() {
    return {
      actions,
      userform,
      message,
      codeFocus: false,
      codeError: false,
      codeTime: 120,
      codeGot: false,
      warn: null
    }
  },
  watch: {
    $route(to, from) {
      this.codeError = false
    }
  },
  computed: {
    codeAction() {
      return this.codeGot ? userform.hint.code.got.replace(/[\d%]+/, this.codeTime) : userform.hint.code.get
    }
  },
  directives: {
    focus: vFocus
  },
  components: {
    Icon,
    Button,
    Poptip
  },
  methods: {
    doFocus() {
      this.codeFocus = 1
      this.$emit('focus')
    },
    doBlur() {
      this.codeFocus = 0
      this.$emit('blur')
    },
    showError(error) {
      this.warn = this.userform.hint.code[error.type] || message.content[error.type].replace('%', error.target || userform.field.code)
      this.codeFocus = this.codeError = true
    },
    getCode() {
      if (this.codeGot) return
      this.$emit('validate')
      this.$nextTick(() => {
        if (this.mobileError) return
        // 获取验证码
        this.codeError = false
        global.$ComAxios.get(this.$ComDomain.User.code, { params: Object.assign({}, this.user, { msgType: msgType[this.process] }) })
          .then(response => {
            if (response.status == 200 && response.data.status == 200) {
              this.codeGot = true
              this.$emit('code-got')
              let _codeTime = this.codeTime
              let timer = setInterval(() => {
                this.codeTime--
                if (!this.codeTime) {
                  this.codeGot = false
                  this.$emit('code-lose')
                  this.codeTime = _codeTime
                  clearInterval(timer)
                }
              }, 1000)
            } else {
              if (response.data.status == 102005) {
                this.user.mobile += '\t'
                this.$emit('validate')
              } else {
                if (response.data.status != 500) {
                  this.warn = response.data.msg
                } else {
                  this.warn = message.content.error.replace('%', this.userform.hint.code.send)
                }
                this.codeFocus = this.codeError = true
              }
            }
          }).catch(error => {
            console.debug(error)
          })
      })
    }
  },
  created() {
    this.$on('code-error', this.showError)
    // 校验验证码
    this.$on('validate-then', fn => {
      if (!this.user.ic) {
        this.showError({ type: 'input' })
        return false
      }
      fn && fn()
    })
  }
}

</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/commons/components/CodeGetter.vue